import Inputmask from "inputmask";

function setMasks () {
  const phoneElems = document.getElementsByClassName("phone_number_formatter");
  Inputmask({ mask: "(99) 99999-9999" }).mask(phoneElems);

  Inputmask({ regex: "\\d{3}\\.\\d{3}\\.\\d{3}\\-\\d{2}" }).mask(
    document.getElementsByClassName("cpf_formatter")
  );

  Inputmask({ regex: "\\d{2}\\.\\d{3}\\.\\d{3}\\/\\d{4}-\\d{2}" }).mask(
    document.getElementsByClassName("cnpj_formatter")
  );
}

window.setMasks = setMasks;
setMasks();
